import _ from 'lodash';
import React from 'react';
import autobind from 'autobind-decorator';
import { inject, observer } from 'mobx-react';

import GenreRow from './genre-row';
import GenreModal from './genre-modal';
import AddGenre from './add-genre';

@inject('genreStore')
@observer
class GenreList extends React.Component {
	render () {
		const { genreStore } = this.props;

		if (genreStore.isLoading) {

			return (<div className="loading-spinner large"></div>);
		}

		return (
			<div className="grid-x grid-padding-x">
				<div className="cell small-12">
					<div className="grid-x align-bottom">
						<div className="cell small-12 padding-left-1">
							<h3 data-ta="genresHeader">Manage Genres</h3>
						</div>
						<div className="cell small-12">
							<GenreModal buttonLabel="Add Genre" icon="plus" title="Add Genre"/>
						</div>
					</div>

					<div className="grid-x grid-padding-x manage-genre-list-container">
						{
							genreStore.sortedGenreList.map((genre) => (
								<GenreRow genre={ genre } key={ genre._id } />
							))
						}
					</div>
				</div>
			</div>
		);
	}
}

export default GenreList;
